<template>
<div>
  <v-row>
    <v-col md="8" cols="12">
      <AppTextField
        :model-value="titleFormField.$model"
        required
        class="required document-name-input"
        :disabled="isEditingLimited"
        :label="$t('project.signing-checklist.add.step2.Section1.documentNameLabel')"
        counter="70"
        maxlength="70"
        :error-messages="titleErrorMessages"
        data-locator="file-name-input"
        @update:model-value="documentNameChange"
      >
      </AppTextField>
    </v-col>
    <v-col md="4" cols="12">
      <AppDatePicker
        class="document-signature-date-input"
        :modelValue="fileDate"
        :disabled="isEditingLimited"
        :label="$t('project.signing-checklist.add.step2.Section1.dateLabel')"
        :placeholder="$t('project.signing-checklist.add.step2.Section1.datePlaceholder')"
        data-locator="signature-date-input"
        @update:model-value="signatureDateChange"
      ></AppDatePicker>
    </v-col>
  </v-row>
</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { mapMutations } from 'vuex'

import AppDatePicker from '@/common/AppDatePicker.vue'
import AppTextField from '@/common/AppTextField.vue'
import { dateToStringDateTime } from '@/common/utils/dates'
import { formFieldErrors, VuelidateFormField } from '@/common/utils/form'
import { SET_IMPORTED_FILE_DOCUMENT_NAME, SET_IMPORTED_FILE_SIGNATURE_DATE } from '@/store/modules/signing-checklist/mutation_types'

export default defineComponent({
  name: 'Section1',
  components: {
    AppTextField,
    AppDatePicker,
  },
  props: {
    fileId: {
      type: Number,
      required: true,
    },
    fileDate: {
      required: true,
      validator: (value) => {
        return typeof value === 'string' || typeof value === 'object'
      },
    },
    isEditingLimited: {
      type: Boolean,
      required: true,
    },
    titleFormField: {
      type: Object as PropType<VuelidateFormField>,
      required: true,
    },
  },
  computed: {
    titleErrorMessages (): Array<string> {
      return formFieldErrors(
        this.titleFormField,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.signing-checklist.add.step2.Section1.documentNameLabel') })],
        ],
      )
    },
  },
  methods: {
    ...mapMutations('signingChecklist', [SET_IMPORTED_FILE_DOCUMENT_NAME, SET_IMPORTED_FILE_SIGNATURE_DATE]),
    documentNameChange (documentName: string) {
      this[SET_IMPORTED_FILE_DOCUMENT_NAME]({
        fileId: this.fileId,
        documentName: documentName.trim(),
      })
    },
    signatureDateChange (signatureDate: object | string) {
      this[SET_IMPORTED_FILE_SIGNATURE_DATE]({
        fileId: this.fileId,
        signatureDate: dateToStringDateTime(signatureDate),
      })
    },
  },
})
</script>
